import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHealthCheckStats } from '../../api/healthCheck';
import store from '../index';
import { setNotifications } from '../slices/notifications';

export const getHealthCheckStatsThunk = createAsyncThunk(
    'healthCheck/getHealthCheckStats',
    async (queryParams: any, { rejectWithValue }) => {
        try {
            const stats = await getHealthCheckStats(queryParams);
            return stats;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
); 